import React from 'react';
import { CheckCircleIcon, ClockIcon, AlertCircleIcon, ChevronRightIcon } from 'lucide-react';
interface EscrowStage {
  name: string;
  status: 'completed' | 'in-progress' | 'pending';
  date: string | null;
}
interface EscrowTransaction {
  id: string;
  propertyName: string;
  location: string;
  price: string;
  status: string;
  stage: string;
  image: string;
  progress: number;
  startDate: string;
  estimatedCompletion?: string;
  completionDate?: string;
  stages: EscrowStage[];
}
interface EscrowDetailsProps {
  transaction: EscrowTransaction;
}
const EscrowDetails: React.FC<EscrowDetailsProps> = ({
  transaction
}) => {
  return <div className="border border-gray-200 rounded-lg mb-6 last:mb-0 overflow-hidden" data-id="element-103">
      <div className="p-4 border-b border-gray-200 bg-gray-50" data-id="element-104">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between" data-id="element-105">
          <div className="flex items-center mb-3 md:mb-0" data-id="element-106">
            <img src={transaction.image} alt={transaction.propertyName} className="w-16 h-16 object-cover rounded-lg mr-4" data-id="element-107" />
            <div data-id="element-108">
              <div className="flex items-center" data-id="element-109">
                <h3 className="font-bold" data-id="element-110">{transaction.propertyName}</h3>
                <span className={`ml-3 px-2 py-1 text-xs rounded-full ${transaction.status === 'Completed' ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-800'}`} data-id="element-111">
                  {transaction.status}
                </span>
              </div>
              <p className="text-gray-600 text-sm" data-id="element-112">{transaction.location}</p>
              <p className="text-green-600 font-medium" data-id="element-113">{transaction.price}</p>
            </div>
          </div>
          <div className="flex flex-col items-end" data-id="element-114">
            <div className="text-sm text-gray-600 mb-1" data-id="element-115">
              <span className="font-medium" data-id="element-116">Escrow ID:</span> {transaction.id}
            </div>
            <div className="text-sm text-gray-600" data-id="element-117">
              <span className="font-medium" data-id="element-118">Started:</span>{' '}
              {transaction.startDate}
            </div>
          </div>
        </div>
      </div>
      <div className="p-4" data-id="element-119">
        <div className="mb-4" data-id="element-120">
          <div className="flex justify-between mb-1" data-id="element-121">
            <span className="text-sm text-gray-600" data-id="element-122">
              {transaction.status === 'Completed' ? 'Completed' : 'In Progress - ' + transaction.stage}
            </span>
            <span className="text-sm font-medium" data-id="element-123">{transaction.progress}%</span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-124">
            <div className="bg-green-600 h-2 rounded-full" style={{
            width: `${transaction.progress}%`
          }} data-id="element-125"></div>
          </div>
        </div>
        <div className="space-y-4" data-id="element-126">
          {transaction.stages.map((stage, index) => <div key={index} className="flex" data-id="element-127">
              <div className="mr-3" data-id="element-128">
                <div className={`w-6 h-6 rounded-full flex items-center justify-center ${stage.status === 'completed' ? 'bg-green-600 text-white' : stage.status === 'in-progress' ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-500'}`} data-id="element-129">
                  {stage.status === 'completed' ? <CheckCircleIcon size={14} data-id="element-130" /> : stage.status === 'in-progress' ? <ClockIcon size={14} data-id="element-131" /> : <AlertCircleIcon size={14} data-id="element-132" />}
                </div>
                {index < transaction.stages.length - 1 && <div className="h-full w-0.5 bg-gray-200 mx-auto mt-1" data-id="element-133"></div>}
              </div>
              <div className="flex-grow pb-4" data-id="element-134">
                <div className="flex justify-between text-sm" data-id="element-135">
                  <p className={`font-medium ${stage.status === 'completed' ? 'text-green-600' : stage.status === 'in-progress' ? 'text-blue-600' : 'text-gray-500'}`} data-id="element-136">
                    {stage.name}
                  </p>
                  {stage.date && <p className="text-gray-600" data-id="element-137">{stage.date}</p>}
                </div>
                {stage.status === 'in-progress' && <p className="text-xs text-blue-600 mt-1" data-id="element-138">In progress</p>}
              </div>
            </div>)}
        </div>
        <div className="mt-4 flex justify-between items-center" data-id="element-139">
          <div className="text-sm text-gray-600" data-id="element-140">
            {transaction.status === 'Completed' ? <span data-id="element-141">
                <span className="font-medium" data-id="element-142">Completed on:</span>{' '}
                {transaction.completionDate}
              </span> : <span data-id="element-143">
                <span className="font-medium" data-id="element-144">Est. completion:</span>{' '}
                {transaction.estimatedCompletion}
              </span>}
          </div>
          <button className="flex items-center text-green-600 hover:text-green-700 font-medium" data-id="element-145">
            View Details
            <ChevronRightIcon size={16} className="ml-1" data-id="element-146" />
          </button>
        </div>
      </div>
    </div>;
};
export default EscrowDetails;